module.exports = __webpack_public_path__ + "static/KlavikaBasic-Medium.fb5fa0b0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/KlavikaBasic-Medium.ttf
// module id = 280
// module chunks = 114276838955818